import { Text, Title } from './../../Typography';
import {
  CategoryBox,
  HeaderContainer,
  HeaderContainerFlex,
  HeaderInnerContainer,
  HeaderTextArea,
  ImageArea,
  Background,
  MaskBottom
} from './styles';
import { CurveMask } from "../../CurveMask";
import React from "react";
import { getCopy } from "../../../lib/utils/getCopy";
import { DictionaryItem } from "../../../types/Dictionary";

function PressHeader({ type, data, dictionary }: { type: string; data: any, dictionary: DictionaryItem[] }) {
  return (
    <HeaderContainer>
      <Background className="curve-mask-top" $customColor={'rgb(1, 14, 84)'}>
        <MaskBottom className="curve-mask-bottom">
          <HeaderInnerContainer className={`type-${type}`}>
            <HeaderContainerFlex>
              <HeaderTextArea>
                {data?.market &&
                  <CategoryBox>
                    <Text type="lead" tag="p">
                      {getCopy(`market_${data.market}`, dictionary)}
                    </Text>
                  </CategoryBox>
                }
                <Title tag="h1" type="lg" className="py-4">
                  {data?.title}
                </Title>
                <Text type="lg" tag="p">
                  {data?.teaser}
                </Text>
              </HeaderTextArea>
              <ImageArea>
                {data?.image?.url &&
                  <img src={data.image.url ?? ''} alt={data.title} width="100%" />
                }
              </ImageArea>
            </HeaderContainerFlex>
          </HeaderInnerContainer>
          <CurveMask />
        </MaskBottom>
      </Background>
    </HeaderContainer>
  );
}

export default PressHeader;
